<app-subscription-grouping-quiz-area-modify
*ngIf="syllabusInfo"
[newQuizRequest]="newQuizRequest"
[subscriptionGrouping]="subscriptionGrouping"
></app-subscription-grouping-quiz-area-modify>
<fieldset class="text-center alert">
    <button [disabled]="creating" class="btn btn-primary margin-50-right"  (click)="createQuiz()">
        <i class="fa fa-plus"></i> <span *ngIf="creating" class="spinner-border spinner-border-sm me-1"></span>
         Save And Create</button>
    <button class="btn btn-warning"  (click)="cancelCreateQuiz()"><i class="fa fa-cross"></i> Cancel</button>
</fieldset>
